import React, { FC } from 'react';
import { useParams, Navigate } from 'react-router-dom';

import ManagerEditPersonalPage from '../ManagerEditPersonalPage';
import SecurityPage from '../../security/SecurityPage';
import ActivityLogView from '../ActivityLogView';
import { ManagerTabType } from '../ManagersMainPage';

export const ManagerPersonalTabRenderer: FC = () => {
    const params = useParams();
    const personalTab = params.personalTab as ManagerTabType;

    switch (personalTab) {
        case ManagerTabType.DETAILS:
            return <ManagerEditPersonalPage />;
        case ManagerTabType.SECURITY:
            return <SecurityPage />;
        case ManagerTabType.ACTIVITY_LOG:
            return <ActivityLogView />;
        default:
            return <Navigate to={'/personal/details'} />;
    }
};
